"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyGetter = void 0;
const validator_1 = require("@leavy/validator");
function ReadonlyGetter() {
    return (target, propertyKey) => {
        (0, validator_1.Expose)({ toPlainOnly: true })(target, propertyKey);
        (0, validator_1.Exclude)({ toClassOnly: true })(target, propertyKey);
    };
}
exports.ReadonlyGetter = ReadonlyGetter;
//# sourceMappingURL=ReadonlyGetter.js.map